export enum CreditPullCountryOption {
	UnitedStates = 'usa',
	Canada = 'canada'
}
